import '.n{position:relative;}.ssr-plugin'
import '.bj{overflow:hidden;}.ssr-plugin'
import '.f4{display:inline-flex;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a8{background:transparent;}.ssr-plugin'
import '.a9{cursor:pointer;}.ssr-plugin'
import '.fk{outline:none;}.ssr-plugin'
import { radius } from '../../utils/radius.js'
import { Icon } from '../Icon/index.js'
import { colors } from '../../tokens/colors.js'
import { styled } from 'inlines'
import { Text } from '../Text/index.js'
import { memo } from 'react'
import { LabelDescription } from '../LabelDescription/index.js'

type CheckboxInputProps = {
  value?: boolean
  onChange: (value: boolean) => void
  onShiftChange?: () => void
  disabled?: boolean
  error?: boolean
  description?: string
  size?: 'regular' | 'small'
  label?: string
  errorMessage?: string
}

const CheckboxInput = ({
  value,
  onChange,
  onShiftChange,
  disabled,
  error,
  description,
  size = 'regular',
  label = '',
  errorMessage,
}: CheckboxInputProps) => {
  return (
    <LabelDescription
      error={error && errorMessage}
      label={description ? label : null}
    >
      <label
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: label ? 'flex-start' : 'center',
          gap: 12,
        }}
      >
        <styled.div className="n bj f4 c d a8 a9 fk"
          data-disabled={disabled ? disabled : undefined}
          data-checked={value ? value : undefined}
          data-error={error ? true : undefined}
          onMouseDown={(e: React.MouseEvent<HTMLInputElement>) => {
            if (e.shiftKey) {
              e.preventDefault()
              onShiftChange?.()
            }
          }}
          style={{
            width: size === 'small' ? 16 : 20,
            height: size === 'small' ? 16 : 20,
            borderRadius: radius[4],
            border: `1px solid ${colors.neutral20Adjusted}`,
            color: colors.neutralInverted100,
            '&[data-checked]': {
              border: `1px solid ${colors.neutral100}`,
              background: colors.neutral100,
            },
            '&:has(:focus-visible):not([data-disabled])': {
              outline: `4px solid ${colors.neutral20Adjusted}`,
            },
            '&[data-error]': {
              border: `1px solid ${colors.red100}`,
            },
            '&[data-error][data-checked]': {
              background: colors.red100,
            },
            '&[data-error]:has(:focus-visible):not([data-disabled])': {
              outline: `4px solid ${colors.red60}`,
            },
            '&[data-disabled], &[data-disabled][data-checked]': {
              cursor: 'not-allowed',
              border: `1px solid transparent`,
              background: colors.neutral20,
            },
          }}
        >
          {value && (
            <span
              style={{
                position: 'absolute',
                pointerEvents: 'none',
                left: size === 'small' ? -1 : -3,
                top: size === 'small' ? -1 : -3,
              }}
            >
              <Icon size={size} variant="checkmark-normal" color="inherit" />
            </span>
          )}
          <input
            style={{
              position: 'absolute',
              width: 1,
              height: 1,
              padding: 0,
              margin: -1,
              overflow: 'hidden',
              clip: 'rect(0, 0, 0, 0)',
              whiteSpace: 'nowrap',
              borderWidth: 0,
            }}
            type="checkbox"
            checked={value ?? false}
            onChange={() => {
              if (disabled) return
              onChange(!value)
            }}
            disabled={disabled}
          />
        </styled.div>
        {(description || label) && (
          <Text
            variant="display-regular"
            color={value && !disabled ? 'neutral100' : 'neutral60'}
          >
            {description || label}
          </Text>
        )}
      </label>
    </LabelDescription>
  )
}

// const MemoizedCheckboxInput = memo(CheckboxInput)

export type { CheckboxInputProps }
export { CheckboxInput }
